import { Box, Typography } from "@mui/material";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  LOAD_DISTRIBUTION_FORM_I18N_PREFIX,
  LOAD_DISTRIBUTION_SUMMARY_CARDS,
  LoadDistributionSummaryTheme,
} from "../data";
import { useStyles } from "./styles";

const summaryCardClassMap: Record<LoadDistributionSummaryTheme, string> = {
  yellow: "summaryCardYellow",
  green: "summaryCardGreen",
  blue: "summaryCardBlue",
};

const summaryValueClassMap: Record<LoadDistributionSummaryTheme, string> = {
  yellow: "summaryValueYellow",
  green: "summaryValueGreen",
  blue: "summaryValueBlue",
};

const Summary = () => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <Box className={styles.summaryRow}>
      {LOAD_DISTRIBUTION_SUMMARY_CARDS.map((card) => (
        <Box
          key={card.key}
          className={clsx(
            styles.summaryCard,
            styles[summaryCardClassMap[card.theme] as keyof typeof styles]
          )}
        >
          <Typography className={styles.summaryTitle}>{t(card.titleKey)}</Typography>
          <Typography
            className={clsx(
              styles.summaryValue,
              styles[summaryValueClassMap[card.theme] as keyof typeof styles]
            )}
          >
            {card.value}
          </Typography>
          <Typography className={styles.summaryFooter}>
            {t(`${LOAD_DISTRIBUTION_FORM_I18N_PREFIX}.SUMMARY.OUT_OF_KG`, {
              total: card.total,
            })}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Summary;
